import { render } from "./Guidance.vue?vue&type=template&id=798d187e&scoped=true&ts=true"
import script from "./Guidance.vue?vue&type=script&lang=ts"
export * from "./Guidance.vue?vue&type=script&lang=ts"

import "./Guidance.vue?vue&type=style&index=0&id=798d187e&scoped=true&lang=scss"

import exportComponent from "/Users/goyuntae/Desktop/bucket-list/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-798d187e"]])

export default __exports__